module.exports = __webpack_public_path__ + "img/WP2023-attending-1200-630.766f58d6.png";